import { useIsFetching } from '@tanstack/react-query'

import { GET_BID_API_ID } from '@/features/bidding/endpoints/bids'

export function useIsFetchingBidQuery(): boolean {
  const bidFetchingCount = useIsFetching({ queryKey: [GET_BID_API_ID] })

  return bidFetchingCount > 0
}
